import {Form, FormInstance, Modal, Select} from "antd";
import React from "react";
import TextArea from "antd/es/input/TextArea";

interface IAssetCategory {
    id: string,
    name: string
}

interface IAssetRequestProps {
    assetRequestModal: boolean;
    handleAssetRequestModalClose: () => void;
    assetRequestForm: FormInstance;
    assetCategoryData: IAssetCategory[];
    handleAssetRequestSubmit: () => void;
}

const AssetRequestModal = (props: IAssetRequestProps) => {

    return (
        <Modal
            title={"Request New Asset"}
            className={"hrms-app asset-request-modal"}
            open={props.assetRequestModal}
            onCancel={props.handleAssetRequestModalClose}
            onOk={props.handleAssetRequestSubmit}
        >
            <Form form={props.assetRequestForm}>
                <Form.Item
                    label={"Select Category"}
                    name={'categoryId'}
                    rules={[{required: true, message: "Please select category!"}]}
                >
                    <Select placeholder={"Select category"}>
                        {
                            props.assetCategoryData.map((category: IAssetCategory) => (
                                <Select.Option key={category.id} value={category.id}>
                                    {category.name}
                                </Select.Option>
                            ))
                        }
                    </Select>
                </Form.Item>
                <Form.Item
                    label={"Specify Asset"}
                    name={'employeeRemarks'}
                    rules={[{required: true, message: "Please specify asset!"}]}
                >
                    <TextArea placeholder={'Describe required asset'}/>
                </Form.Item>
            </Form>
        </Modal>
    )
}

export default AssetRequestModal;
